export { Colors as default } from '@rockalingua/ui';
